(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('.section-scroll');

  links.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('href');
      const targetEl = document.querySelector('.why-buy');
      const header = document.querySelector('.header-section');

      if (!targetEl) return;

      const headerHeight = header ? header.offsetHeight : 0;

      const targetPosition =
        targetEl.getBoundingClientRect().top +
        window.pageYOffset -
        (headerHeight + 30);

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });
    });
  });
}); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.faq-item');

  items.forEach((item) => {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');

    // reset initial state
    answer.style.height = '0px';
    answer.style.overflow = 'hidden';

    question.addEventListener('click', (e) => {
      e.preventDefault();
      
      const isOpen = item.classList.contains('is-open');

      // close all (accordion behavior)
      items.forEach((i) => {
        if (i !== item) closeItem(i);
      });

      if (isOpen) {
        closeItem(item);
      } else {
        openItem(item);
      }
    });
  });

  function openItem(item) {
    const answer = item.querySelector('.faq-answer');

    item.classList.add('is-open');

    answer.style.display = 'block';
    const height = answer.scrollHeight;

    answer.style.height = '0px';

    requestAnimationFrame(() => {
      answer.style.height = height + 'px';
    });

    answer.addEventListener(
      'transitionend',
      () => {
        if (item.classList.contains('is-open')) {
          answer.style.height = 'auto';
        }
      },
      { once: true }
    );
  }

  function closeItem(item) {
    const answer = item.querySelector('.faq-answer');

    const height = answer.scrollHeight;

    answer.style.height = height + 'px';

    requestAnimationFrame(() => {
      answer.style.height = '0px';
    });

    item.classList.remove('is-open');
  }
});
  document.addEventListener("DOMContentLoaded", function () {
  const faqBlocks = document.querySelectorAll('.faq-block[data-faq-schema]');
  if (!faqBlocks.length) return;

  const existingSchemas = document.querySelectorAll('script[type="application/ld+json"]');
  for (const node of existingSchemas) {
    try {
      const parsed = JSON.parse(node.textContent);
      const items = Array.isArray(parsed) ? parsed : [parsed];
      if (items.some(item => item && (item['@type'] === 'FAQPage' || (Array.isArray(item['@type']) && item['@type'].includes('FAQPage'))))) {
        return;
      }
    } catch (e) {}
  }

  const mainEntity = [];

  faqBlocks.forEach(block => {
    block.querySelectorAll('.faq-item').forEach(item => {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');

      if (!question || !answer) return;

      mainEntity.push({
        "@type": "Question",
        "name": question.textContent.trim(),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": answer.textContent.trim()
        }
      });
    });
  });

  if (!mainEntity.length) return;

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": mainEntity
  };

  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-no-usf"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  document.addEventListener('DOMContentLoaded', function () {
    // Product Slider initialize
        const cardPromoSlider = document.querySelector('.promo-swiper');
        if (!cardPromoSlider) return;
        
        // @ts-ignore
      //   const cardPromoSwiper = new Swiper('.promo-swiper', {
      //       slidesPerView: 1,
      //       loop: false,
      //       pagination: {
      //         el: '.promo-swiper .swiper-pagination',
      //         clickable: true,
      //       },
      //       on: {
      //   sliderMove: function () {
      //     this.pagination.update();
      //   },
      //   slideChange: function () {
      //     this.pagination.update();
      //   }
      // }
      //   });
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  document.addEventListener('DOMContentLoaded', function () {
    // Product Slider initialize
        const cardPromoSlider = document.querySelector('.promo-swiper');
        if (!cardPromoSlider) return;
        
        // @ts-ignore
  //       const cardPromoSwiper = new Swiper('.promo-swiper', {
  //           slidesPerView: 1,
  //           loop: false,
  //           followFinger: true,
  // watchSlidesProgress: true,
  //           pagination: {
  //             el: '.promo-swiper .swiper-pagination',
  //             clickable: true,
  //           },
  //           on: {
  //       sliderMove: function () {
  //         this.pagination.update();
  //       },
  //       slideChange: function () {
  //         this.pagination.update();
  //       }
  //     }
  //       });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('.section-scroll');

  links.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('href');
      const targetEl = document.querySelector('.why-buy');
      const header = document.querySelector('.header-section');

      if (!targetEl) return;

      const headerHeight = header ? header.offsetHeight : 0;

      const targetPosition =
        targetEl.getBoundingClientRect().top +
        window.pageYOffset -
        (headerHeight + 30);

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (!window.matchMedia('(max-width: 1279px)').matches) return;

  const scrollToUsfContainer = () => {
    const targetEl = document.getElementById('usf_container');
    const header = document.querySelector('.header-section');

    if (!targetEl) return;

    const headerHeight = header ? header.offsetHeight : 0;

    const targetPosition =
      targetEl.getBoundingClientRect().top +
      window.pageYOffset -
      (headerHeight + 30);

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  };

  scrollToUsfContainer();

  // USF can remount the container after boot; re-align once layout settles.
  setTimeout(scrollToUsfContainer, 100);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usf-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  document.addEventListener('DOMContentLoaded', function () {

  setTimeout(() => {
    // Product Slider initialize
    // const cardPromoSlider = document.querySelector('.promo-swiper');
    // if (!cardPromoSlider) return;

    // @ts-ignore
  //   const cardPromoSwiper = new Swiper('.promo-swiper', {
  //     slidesPerView: 1,
  //     loop: false,
  //     followFinger: true,
  // watchSlidesProgress: true,
  //     pagination: {
  //       el: '.promo-swiper .swiper-pagination',
  //       clickable: true,
  //     },
  //     on: {
  //       sliderMove: function () {
  //         this.pagination.update();
  //       },
  //       slideChange: function () {
  //         this.pagination.update();
  //       }
  //     }
  //   });

  }, 1000); // adjust delay if needed (300ms–1000ms)
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-buy-pdp"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    initLogoSwiper2();
  });
  let logoSwiper2 = null;
  function initLogoSwiper2() {
    if (window.innerWidth <= 1023 && !logoSwiper2) {
      logoSwiper2 = new Swiper('.why-buy__logos', {
        slidesPerView: 3,
        loop: false,
        scrollbar: {
            el: '.why-buy__logos .swiper-scrollbar',
            hide: false,
            draggable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 5,
            },
          },
      });
    } else if (window.innerWidth > 1023 && logoSwiper2) {
      logoSwiper2.destroy(true, true);
      logoSwiper2 = null;
    }
  }
  window.addEventListener('resize', () => {
    initLogoSwiper2();
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-buy"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    initLogoSwiper2();
  });
  let logoSwiper2 = null;
  function initLogoSwiper2() {
    if (window.innerWidth <= 1023 && !logoSwiper2) {
      logoSwiper2 = new Swiper('.why-buy__logos', {
        slidesPerView: 3,
        loop: false,
        scrollbar: {
            el: '.why-buy__logos .swiper-scrollbar',
            hide: false,
            draggable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 5,
            },
          },
      });
    } else if (window.innerWidth > 1023 && logoSwiper2) {
      logoSwiper2.destroy(true, true);
      logoSwiper2 = null;
    }
  }
  window.addEventListener('resize', () => {
    initLogoSwiper2();
  });
  
  } catch(e) { console.error(e); }
})();
})();
